export default "__VITE_ASSET__DH1Dm0M4__"